import PosthogService from '~/services/posthog/PosthogService';

export function fireMenuBarReferralClicked(): void {
  PosthogService.getInstance().track('dental_portal:menu_bar:referral_clicked');
}
